import { motion } from 'framer-motion';
import { useLang } from '../../../context/LangContext';
import { CurrencySelector } from '../../shared/CurrencySelector';

export const TarifsHero = ({ isAnnual, setIsAnnual }) => {
  const { t } = useLang();

  return (
    <section data-testid="tarifs-hero" className="relative pt-32 pb-12 bg-[#0A0A0A] overflow-hidden">
      {/* Background glows */}
      <motion.div
        className="absolute rounded-full blur-[120px] opacity-20 bg-brand-green w-96 h-96 top-1/4 left-1/4"
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute rounded-full blur-[100px] opacity-15 bg-brand-gold w-80 h-80 bottom-1/3 right-1/4"
        animate={{ scale: [1, 1.12, 1] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: 3 }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center px-4 py-2 rounded-full border border-brand-green/40 bg-brand-green/10 text-brand-green text-sm font-medium mb-8"
        >
          {t("tarifs.hero.badge")}
        </motion.div>

        {/* Title */}
        <motion.h1
          className="font-extrabold tracking-[-0.03em] leading-[1.05] text-white mb-6"
          style={{ fontSize: 'clamp(36px, 5vw, 56px)' }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {t("tarifs.hero.title")}
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          className="text-neutral-400 text-lg max-w-2xl mx-auto leading-relaxed mb-10"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {t("tarifs.hero.subtitle")}
        </motion.p>

        {/* Currency Selector + Toggle */}
        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          {/* Currency Selector */}
          <CurrencySelector />

          {/* Monthly/Annual Toggle */}
          <div className="flex items-center gap-3 bg-white/[0.04] rounded-full p-1.5">
            <button
              onClick={() => setIsAnnual(false)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                !isAnnual
                  ? 'bg-white/[0.1] text-white'
                  : 'text-neutral-400 hover:text-white'
              }`}
              data-testid="toggle-monthly"
            >
              {t("tarifs.toggle.monthly")}
            </button>
            <button
              onClick={() => setIsAnnual(true)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all flex items-center gap-2 ${
                isAnnual
                  ? 'bg-white/[0.1] text-white'
                  : 'text-neutral-400 hover:text-white'
              }`}
              data-testid="toggle-annual"
            >
              {t("tarifs.toggle.annual")}
              <span className="px-2 py-0.5 rounded-full bg-brand-green/20 text-brand-green text-xs font-bold">
                {t("tarifs.toggle.save")}
              </span>
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
